import React from 'react';
import PropTypes from 'prop-types';

class BasicInput extends React.Component {
  static propTypes = {
    touched: PropTypes.any,
    errors: PropTypes.any,
    handleChange: PropTypes.any,
    handleBlur: PropTypes.any,
    values: PropTypes.any,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    label: PropTypes.string,
    help: PropTypes.string,
    noFormGroup: PropTypes.bool,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    required: PropTypes.bool,
    ajaxErrors: PropTypes.object
  };

  render() {
    const {
      touched,
      errors,
      handleChange,
      handleBlur,
      values,
      name,
      placeholder,
      label,
      help,
      noFormGroup,
      onChange,
      onBlur,
      required,
      ajaxErrors
    } = this.props;

    const className = this.props.className ? this.props.className : '';

    return (
      <div
        className={
          (touched[name] && errors[name]) ||
          (ajaxErrors && !touched[name] && ajaxErrors[name])
            ? (noFormGroup ? '' : 'form-group m-form__group ') + 'has-danger'
            : noFormGroup
            ? ''
            : 'form-group m-form__group '
        }
      >
        {label && (
          <label htmlFor={name}>
            {label} {required ? '*' : ''}
          </label>
        )}

        <textarea
          required={!!required}
          className={'form-control m-input ' + className}
          placeholder={placeholder}
          name={name}
          id={name}
          onChange={e => {
            handleChange(e);
            if (onChange) {
              onChange(e);
            }
          }}
          onBlur={e => {
            handleBlur(e);
            if (onBlur) {
              onBlur(e);
            }
          }}
          value={values[name]}
        />
        {help && <span className="m-form__help">{help}</span>}
        {touched[name] && errors[name] && (
          <div className="form-control-feedback">{errors[name]}</div>
        )}
        {ajaxErrors && !touched[name] && ajaxErrors[name] && (
          <div className="form-control-feedback">{ajaxErrors[name]}</div>
        )}
      </div>
    );
  }
}

export default BasicInput;
